import React from 'react';
import { deletePreformException } from '../../../api/PreEForm';
import { confirmAlert } from 'react-confirm-alert';
import ExceptionDeleteConfirm from "./ExceptionDeleteConfirm";

const textStyle = {
    width: "90%",
    overflow: "hidden",
    textOverflow: "ellipsis",
    position: "relative",
    whiteSpace: "nowrap"
};

const PreEFormExceptionDeleteDialogBody = ({ title, situation }) => (
    <div >
        <div><strong>Title:</strong>&nbsp;{title}</div>

        <div style={textStyle}><strong>Situation:</strong>&nbsp;{situation}</div>

    </div>
);


const ShowPreEFormExceptionDeleteDialog = (props) => {

    const { preEnergizationFormException, updateFormState, updateState } = props;
    //console.log('preEnergizationFormException',preEnergizationFormException);
    const options = {
        closeOnEscape: true,
        closeOnClickOutside: false,
        customUI: ({ onClose }) => <ExceptionDeleteConfirm
            onClose={ ()=>{onClose();} }
            onAccept={ async () => {
                await deletePreformException({ preEnergizationFormException : preEnergizationFormException });
                preEnergizationFormException.preEnergizationFormExceptionId = null;
                updateState(preEnergizationFormException);
                updateFormState();
                onClose();
            }}
            headerText={preEnergizationFormException.status === 'Approved' ? 'Are you sure you want to delete this Approved Exception?'
            : 'Are you sure you want to delete this Exception?'}
            body={<PreEFormExceptionDeleteDialogBody title={preEnergizationFormException.title} situation={preEnergizationFormException.situation} />}
        />
    };
    confirmAlert(options);
};

export default ShowPreEFormExceptionDeleteDialog;
